import { api } from './base.api.client'
import type {
  ActionSummary,
  ExecutionResult,
  LookupResult,
} from '@/core/types/api.types'

export const actionsApi = {
  /** What this specific connection can do. */
  available: (connectionId: string) =>
    api.get<{
      connection_id: string
      connector_id: string
      connector_name: string
      actions: ActionSummary[]
    }>(`/connections/${encodeURIComponent(connectionId)}/actions`),

  execute: (
    connectionId: string,
    actionId: string,
    input: Record<string, unknown>,
    opts?: { maxPages?: number; maxItems?: number; signal?: AbortSignal },
  ) =>
    api.post<ExecutionResult>(
      `/connections/${encodeURIComponent(connectionId)}/actions/${encodeURIComponent(actionId)}`,
      { input, max_pages: opts?.maxPages, max_items: opts?.maxItems },
      opts?.signal,
    ),

  /**
   * Populate a dropdown from the connected app.
   *
   * The label/value keys travel as `_`-prefixed inputs because they describe how
   * to *read* the result, not what to send upstream — the executor strips them
   * before templating.
   */
  lookup: (
    connectionId: string,
    actionId: string,
    params: {
      labelKey: string
      valueKey: string
      dependencies?: Record<string, unknown>
      signal?: AbortSignal
    },
  ) =>
    api.post<LookupResult>(
      `/connections/${encodeURIComponent(connectionId)}/lookup/${encodeURIComponent(actionId)}`,
      {
        input: {
          ...(params.dependencies ?? {}),
          _label_key: params.labelKey,
          _value_key: params.valueKey,
        },
      },
      params.signal,
    ),
}
